import React, { useCallback, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logoImage from '../assets/image/logo1.webp';
import { loginUser, loginWithGoogle } from '../api/userAPI';
import '../css/LoginPage.css';
import { useUser } from '../contexts/UserContext';
import GoogleAuthButton from './GoogleAuthButton';

function LoginPage() {
  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setUser } = useUser();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      const responseData = await loginUser(loginData);
      setUser(responseData.user);
      navigate('/');
    } catch (loginError) {
      console.error('Login failed:', loginError.message);
      setError(loginError.message || 'Failed to login. Please try again.');
    }
  };

  const handleGoogleLogin = useCallback(async (credential) => {
    const responseData = await loginWithGoogle(credential);
    setUser(responseData.user);
    navigate('/');
  }, [navigate, setUser]);

  return (
    <main id="tt-pageContent" className="tt-offset-none">
      <div className="container">
        <div className="tt-loginpages-wrapper">
          <div className="tt-loginpages">
            <Link to="/" className="tt-block-title">
              <img src={logoImage} alt="Logo" className="login-logo" />
              <div className="tt-title">Welcome to InterviewBlogs</div>
              <div className="tt-description">
                Log into your account to unlock the true power of the community.
              </div>
            </Link>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <form className="form-default" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="loginUserEmail">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  id="loginUserEmail"
                  placeholder="email@example.com"
                  value={loginData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="loginUserPassword">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  id="loginUserPassword"
                  placeholder="********"
                  value={loginData.password}
                  onChange={handleChange}
                />
              </div>
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="form-group">
                    <div className="checkbox-group">
                      <input
                        type="checkbox"
                        id="settingsCheckBox01"
                        checked={rememberMe}
                        onChange={(event) => setRememberMe(event.target.checked)}
                      />
                      <label htmlFor="settingsCheckBox01">
                        Remember me
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-auto ml-auto">
                  <Link to="/forgot-password" className="tt-underline">Forgot Password?</Link>
                </div>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-secondary btn-block">Log in</button>
              </div>
              <div className="auth-divider"><span>or continue with</span></div>
              <GoogleAuthButton
                text="signin_with"
                onCredential={handleGoogleLogin}
                onError={(googleError) => setError(googleError.message)}
              />
              <p>Don't have an account? <Link to="/signup" className="tt-underline">Sign up here</Link></p>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LoginPage;
